var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c("StepTitle", [_vm._v("Planes Telco")]),
                  _c("v-divider"),
                  _c("br"),
                  _c(
                    "v-layout",
                    {
                      staticStyle: { "padding-right": "0px" },
                      attrs: { row: "", wrap: "" }
                    },
                    [
                      _c("v-flex", { attrs: { xs12: "", sm6: "", md6: "" } }, [
                        _c(
                          "div",
                          { attrs: { align: "left" } },
                          [
                            _c("BuscadorOperacionCrud", {
                              attrs: {
                                filter:
                                  _vm.gridApi &&
                                  _vm.gridApi.setQuickFilter.bind(_vm.gridApi)
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _c(
                        "v-flex",
                        {
                          staticStyle: { "padding-right": "0px" },
                          attrs: { xs12: "", sm6: "", md6: "" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-top": "6px",
                                "padding-right": "0px"
                              },
                              attrs: { align: "right" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticStyle: {
                                    "padding-right": "20px",
                                    display: "block",
                                    margin: "0 0 0 auto",
                                    "margin-top": "15px"
                                  },
                                  attrs: { color: "#ffe800" },
                                  on: { click: _vm.crear_plan }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticStyle: { color: "black" },
                                      attrs: { dark: "", left: "" }
                                    },
                                    [_vm._v("add_circle_outline")]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "black" } },
                                    [_vm._v("Crear")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "telcofromplanes",
                      attrs: { align: "left" }
                    },
                    [
                      _c("MantenedorGridSinCodigo", {
                        attrs: {
                          "grid-options": _vm.gridOptions,
                          "funcionalidad-id": _vm.funcionalidad
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.showReporteGenerado
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c("div", { staticClass: "ModalEdit" }, [
              _c(
                "div",
                {
                  staticClass: "modalEnvio-content",
                  attrs: { id: "desactivadores" }
                },
                [
                  _c("div", [
                    _vm._m(0),
                    _c(
                      "div",
                      {
                        staticClass: "buttonClose buttonCloseEvidencia",
                        attrs: { align: "right" }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { flat: "", small: "", color: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.closeReporte()
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "importExportBtnIcon" },
                              [_vm._v("close")]
                            ),
                            _vm._v("  \n              "),
                            _c(
                              "span",
                              { staticClass: "importExportBtnTexto" },
                              [_vm._v("Cerrar")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { attrs: { align: "center" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { md10: "" } },
                          [
                            _c(
                              "v-card",
                              { staticClass: "rounded-card" },
                              [
                                _c(
                                  "v-form",
                                  {
                                    ref: "form",
                                    staticClass: "col-md-12",
                                    attrs: { "lazy-validation": "" }
                                  },
                                  [
                                    _c(
                                      "v-container",
                                      {
                                        staticStyle: {
                                          padding: "30px 40px 50px 40px"
                                        },
                                        attrs: { "grid-list-md": "" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "boton_crear" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "icon",
                                                staticStyle: {
                                                  "background-color":
                                                    "rgb(255, 108, 0)",
                                                  "border-color":
                                                    "rgb(255, 108, 0)",
                                                  "padding-right": "20px",
                                                  display: "block",
                                                  margin: "0 0 0 auto"
                                                },
                                                on: { click: _vm.guardar }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    }
                                                  },
                                                  [_vm._v("Guardar")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "FormFieldsContainer",
                                          { attrs: { titulo: "Crear Plan" } },
                                          [
                                            _vm._t("prependInformacionGeneral"),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.id.label,
                                                    disabled: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.id.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields.id,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.id.value"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.plan.label
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.plan.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields.plan,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.plan.value"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "desplegable",
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-autocomplete", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.tipo.label,
                                                    items: _vm.planlist,
                                                    "item-text": "tipo_sim",
                                                    "item-value": "id"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.tipo.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields.tipo,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.tipo.value"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.consumo
                                                        .label
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.consumo
                                                        .value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields.consumo,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.consumo.value"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "desplegable",
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-autocomplete", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.tipoConsumo
                                                        .label,
                                                    items: _vm.tiposConsumos,
                                                    "item-text": "configvalor",
                                                    "item-value": "configid"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.tipoConsumo
                                                        .value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields
                                                          .tipoConsumo,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.tipoConsumo.value"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm.showReporteGeneradoEditar
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c("div", { staticClass: "ModalEdit" }, [
              _c(
                "div",
                {
                  staticClass: "modalEnvio-content",
                  attrs: { id: "desactivadores" }
                },
                [
                  _c("div", [
                    _vm._m(1),
                    _c(
                      "div",
                      {
                        staticClass: "buttonClose buttonCloseEvidencia",
                        attrs: { align: "right" }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { flat: "", small: "", color: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.closeReporteEditar()
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "importExportBtnIcon" },
                              [_vm._v("close")]
                            ),
                            _vm._v("  \n              "),
                            _c(
                              "span",
                              { staticClass: "importExportBtnTexto" },
                              [_vm._v("Cerrar")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { attrs: { align: "center" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { md10: "" } },
                          [
                            _c(
                              "v-card",
                              { staticClass: "rounded-card" },
                              [
                                _c(
                                  "v-form",
                                  {
                                    ref: "form",
                                    staticClass: "col-md-12",
                                    attrs: { "lazy-validation": "" }
                                  },
                                  [
                                    _c(
                                      "v-container",
                                      {
                                        staticStyle: {
                                          padding: "30px 40px 50px 40px"
                                        },
                                        attrs: { "grid-list-md": "" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "boton_crear" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "icon",
                                                staticStyle: {
                                                  "background-color":
                                                    "rgb(255, 108, 0)",
                                                  "border-color":
                                                    "rgb(255, 108, 0)",
                                                  "padding-right": "20px",
                                                  display: "block",
                                                  margin: "0 0 0 auto"
                                                },
                                                on: { click: _vm.editarPlan }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    }
                                                  },
                                                  [_vm._v("Guardar")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "FormFieldsContainer",
                                          { attrs: { titulo: "Editar Plan" } },
                                          [
                                            _vm._t("prependInformacionGeneral"),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.id.label,
                                                    disabled: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.id.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields.id,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.id.value"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.plan.label
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.plan.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields.plan,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.plan.value"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "desplegable",
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-combobox", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.tipo.label,
                                                    items: _vm.planlist,
                                                    "item-text": "tipo_sim",
                                                    "item-value": "id"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.tipo.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields.tipo,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.tipo.value"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.consumo
                                                        .label
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.consumo
                                                        .value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields.consumo,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.consumo.value"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "desplegable",
                                                attrs: {
                                                  xs4: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-autocomplete", {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.tipoConsumo
                                                        .label,
                                                    items: _vm.tiposConsumos,
                                                    "item-text": "configvalor",
                                                    "item-value": "configid"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.tipoConsumo
                                                        .value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields
                                                          .tipoConsumo,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.tipoConsumo.value"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          nombre: _vm.nombrePlanElminar,
          titulo: "Eliminar el plan " + _vm.nombrePlanElminar,
          mensaje: _vm.$t(
            "Después de realizada la acción no se podrá reversar."
          ),
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [_vm._v("Crear Plan")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [_vm._v("Editar Plan")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }